import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalEscalationsRoute: InvariantJiraRoute = {
	name: 'eoc-global-escalations',
	path: '/jira/settings/products/ops/escalation-policies',
	exact: true,
};
